import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

// Async thunk for reseller login
export const ResellerLoginApi = createAsyncThunk(
  "resellerloginData/ResellerLoginApi",
  async (credentials, thunkAPI) => {
    try {
      const response = await axios.post(endPoint.ResellerLoginApi, {
        identifier: credentials.identifier,
        password: credentials.password,
      });
      localStorage.setItem("ResellerTokenData", response?.data?.token);
      localStorage.setItem("role", "reSeller");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

const ResellerLoginSlice = createSlice({
  name: "ResellerLogin",
  initialState: {
    ResellerLogin: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ResellerLoginApi.fulfilled, (state, action) => {
        state.ResellerLogin = action.payload;
      })
      .addCase(ResellerLoginApi.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default ResellerLoginSlice.reducer;
